import MaterialContent from "../../../../views/digibord/content/season/MaterialContent.vue";

export default [
  {
    path: "materiaal/",
    name: "MaterialContent",
    component: MaterialContent,
    meta: {
      containerClass: "showMaterialContent",
    },
    children: [
      {
        path: ":seasonSlug/",
        name: "MaterialContentWithSeason",
        component: MaterialContent,
      },
    ],
  },
];
